// extracted by mini-css-extract-plugin
export default {"titlePage":"settingItem_titlePage__oDY61"};